let _ = t => t,
  _t,
  _t2,
  _t3;
import styled, { css } from 'styled-components';
import { colors, fontSize } from '@ovpn-ui/styles';
import Popper from './Popper';
const tooltipBoxShadow = css(_t || (_t = _`
    box-shadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);
`));
const arrowStyles = css(_t2 || (_t2 = _`
    ${0}
`), ['top', 'bottom', 'left', 'right'].map(t => `
                & .ovpn-popper-arrow[data-placement*="${t}"] {
                    border-${t}-color: ${colors.neutralTextTitle};
                }
                & .ovpn-popper-arrow[data-placement*="${t}"]::after {
                    border-${t}-color: ${colors.neutralTextTitle};
                }
            `));
export const StyledTooltip = styled(Popper)(_t3 || (_t3 = _`
    z-index: 9999;

    display: flex;
    flex-direction: column;

    width: max-content;

    padding: 8px 16px;

    color: ${0};
    font-size: ${0};
    line-height: ${0};

    background-color: ${0};
    border-radius: 8px;
    ${0}

    -webkit-font-smoothing: antialiased;

    pointer-events: ${0};

    .ovpn-popper-arrow {
        pointer-events: none;
    }

    a,
    a:hover,
    a:focus {
        color: ${0} !important;
    }

    ${0}
`), colors.neutralWhite, fontSize.xSmall, fontSize.default, colors.neutralTextTitle, tooltipBoxShadow, t => t.$interactive ? 'all' : 'none', colors.neutralOffwhite, arrowStyles);